!(function () {
  'use strict';
  customElements.get('parallax-hero') ||
    customElements.define(
      'parallax-hero',
      class extends HTMLElement {
        constructor() {
          (super(), (this.rellax = null));
        }
        connectedCallback() {
          const e = this.querySelector('[data-parallax-img]');
          e &&
            ((this.rellax = new window.theme.LoadRellax(this, e)),
            window.addEventListener('load', () => {
              this.rellax && 'function' == typeof this.rellax.refresh && this.rellax.refresh();
            }));
        }
        disconnectedCallback() {
          this.rellax &&
            'function' == typeof this.rellax.destroy &&
            (this.rellax.destroy(), (this.rellax = null));
        }
      }
    );
})();
